/* @flow */
import type { $MapProps } from '../components/MapProviders/Map';
import type { $Coordinates } from '../components/MapProviders/Coordinates';
import type { $MapPadding } from '../types/MapPadding';


export const mapPropsAreDifferent = (props1: $MapProps, props2: $MapProps): boolean => {
  return props1.zoom !== props2.zoom ||
    coordinatesAreDifferent(props1.center, props2.center) ||
    mapPaddingsAreDifferent(props1.mapPadding, props2.mapPadding) ||
    coordinatesAreDifferent(props1.centralPoint, props2.centralPoint) ||
    markersAreDifferent(props1.markers, props2.markers);
}

const mapPaddingsAreDifferent = (mapPadding1?: $MapPadding, mapPadding2?: $MapPadding): boolean => {
  // If one of them exists but the other does not, they are different
  if((mapPadding1 && !mapPadding2) || (mapPadding2 && !mapPadding1)) return true;

  // If both exist but one of their properties is different, they are different
  if(mapPadding1 && mapPadding2 && (
    mapPadding1.top !== mapPadding2.top ||
    mapPadding1.right !== mapPadding2.right ||
    mapPadding1.bottom !== mapPadding2.bottom ||
    mapPadding1.left !== mapPadding2.left
  )) return true;

  // If they are the same, return false
  return false;
}

const coordinatesAreDifferent = (coordinates1?: ?$Coordinates, coordinates2?: ?$Coordinates): boolean => {
  // If one of them exists but the other does not, they are different
  if ((coordinates1 && !coordinates2) || (coordinates2 && !coordinates1)) return true;

  // If both exist but one of their properties is different, they are different
  if (coordinates1 && coordinates2 && (
    coordinates1.lat !== coordinates2.lat ||
    coordinates1.lng !== coordinates2.lng
  )) return true;

  // If they are the same, return false
  return false;
}

const markersAreDifferent = (markers1?: Array<$Coordinates>, markers2?: Array<$Coordinates>): boolean => {
  // If one of them exists but the other does not, they are different
  if ((markers1 && !markers2) || (markers2 && !markers1)) return true;

  if(markers1 && markers2) {
    // If their length is different, they are different
    if (markers1.length !== markers2.length) return true;

    // Evaluate if every element is the same
    return markers1 && !markers1.every((marker, index) =>
      markers2 && markers2[index] && marker.outletId === markers2[index].outletId);
  }

  return false;
}
